import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./Contact.css";

function Contact() {
  return (
    <div className="contact-wrapper">

      
      <section className="contact-hero">
        <div className="hero-content">

          <span className="hero-label">CONTACT</span>

          <h1 className="hero-title">
            Get In <span className="gradient-text">Touch</span>
          </h1>

          <p>
            Have a project in mind? Let’s build something amazing together.
          </p>

        </div>
      </section>

    
      <section className="contact-section">

       
        <div className="contact-info">

          <div className="info-card">
            <FaMapMarkerAlt className="info-icon" />
            <h4>Address</h4>
            <p>
            Phase-1<br />
              14/179, Ganga Nivas <br />
              Kulasekharam Market Junction <br />
              Cherupaloor P.O, India
            </p>
            <p>
              Phase-2<br />
              
              Ashby plaza <br />
              16-2 Nagacode jn , Kulasekharam <br />
            KanniyaKumari-629161
            </p>
          </div>

          <div className="info-card">
            <FaPhoneAlt className="info-icon" />
            <h4>Phone</h4>
            <p>
              +91 63697 24463 <br />
              +91 94867 80846
            </p>
          </div>

          <div className="info-card">
            <FaEnvelope className="info-icon" />
            <h4>Email</h4>
            <p>info@rdstechnology.in</p>
          </div>

        </div>

        <div className="contact-form">
          <h2>Send Message</h2>

          <form>
            <div className="input-group">
              <input type="text" placeholder="Your Name" required />
            </div>

            <div className="input-group">
              <input type="email" placeholder="Your Email" required />
            </div>

            <div className="input-group">
              <input type="text" placeholder="Subject" />
            </div>

            <div className="input-group">
              <textarea placeholder="Your Message" rows="5" required></textarea>
            </div>

            <button type="submit" className="contact-btn">
              Send Message →
            </button>
          </form>

      
          <div className="mini-map">
            <iframe
              title="RDS Technology Location"
              src="https://www.google.com/maps?q=Kulasekharam%20Market%20Junction%20Cherupaloor%20India&output=embed"
              loading="lazy"
            ></iframe>
          </div>

        </div>

      </section>

    </div>
  );
}

export default Contact;